module.exports = __webpack_public_path__ + "img/klinksh.888658b8.jpg";